// ─────────────────────────────────────────────
//  useAlerts.js
// ─────────────────────────────────────────────
import { useState, useEffect } from "react";
import { db } from "../config/firebaseconfig";
import {
  collection, onSnapshot, addDoc, deleteDoc,
  doc, updateDoc, query, where
} from "firebase/firestore";
import { useAuth } from "../context/AuthContext";

export function useAlerts() {
  const { user }  = useAuth();
  const [alerts,  setAlerts]  = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    const ref = collection(db, "users", user.uid, "alerts");
    const q   = query(ref, where("status", "==", "ACTIVE"));
    const unsub = onSnapshot(q, (snap) => {
      setAlerts(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
      setLoading(false);
    });
    return unsub;
  }, [user]);

  const createAlert = (data) =>
    addDoc(collection(db, "users", user.uid, "alerts"), {
      ...data,
      status: "ACTIVE",
      created_at: new Date(),
      notified_via: [],
    });

  const dismissAlert = (id) =>
    updateDoc(doc(db, "users", user.uid, "alerts", id), { status: "DISMISSED" });

  const deleteAlert = (id) =>
    deleteDoc(doc(db, "users", user.uid, "alerts", id));

  return { alerts, loading, createAlert, dismissAlert, deleteAlert };
}
